import React from "react";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { ValidationError } from "../../utils/orderUtils";
import styles from "./ErrorSummary.module.css";

interface ErrorSummaryProps {
  errors: Record<string, ValidationError>;
  title?: string;
  onErrorClick: (fieldId: string) => void;
}

const ErrorSummary: React.FC<ErrorSummaryProps> = ({
  errors,
  title = "Por favor corrija los siguientes errores:",
  onErrorClick,
}) => {
  const errorCount = Object.keys(errors).length;

  if (errorCount === 0) return null;

  return (
    <div
      className={styles.errorSummaryContainer}
      role="alert"
      aria-live="assertive"
    >
      <div className={styles.errorHeader}>
        <ErrorOutlineIcon className={styles.errorIcon} />
        <h4 className={styles.errorTitle}>{title}</h4>
      </div>

      <ul className={styles.errorList}>
        {Object.entries(errors).map(([key, error]) => (
          <li key={key} className={styles.errorItem}>
            <button
              className={styles.errorLink}
              onClick={() => onErrorClick(error.fieldId)}
              type="button"
            >
              {error.message}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ErrorSummary;
